
import styled from "styled-components"
import { BsCheckLg } from "react-icons/bs";


const Container = styled.div`

    display: flex !important;
    flex-direction: row !important;
    align-items: center;
    gap: 5px;

    
    .box{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        border: 1px solid ${({isChecked, theme}) => isChecked ? "var(--color-main)" : theme.mainTextColor};
        border-radius: 3px;
        background-color: ${({isChecked, theme}) => isChecked ? "var(--color-main)" : theme.mainBgColor};
        cursor: pointer;

        .check-icon{
            font-size: 1.6rem;
            fill: ${({isChecked, theme}) => isChecked ? "#fff" : theme.mainTextColor};
        }
    }
    
    span{
        font-size: 12px;
        font-weight: var(--font-weight-md);
        color: ${({theme}) => theme.mainTextColor};
    }
    
`

const InputStopoverCheckbox = ({isChecked, handleClick, labelText, }) => {
  return (
    <Container isChecked={isChecked}>
        <div className="box" onClick={handleClick}>{isChecked && <BsCheckLg  className="check-icon"/>}</div>
        <span>{labelText}</span>
    </Container>
  )
}

export default InputStopoverCheckbox